import Menu from "../../components/Menu/Menu";
import NewMenu from "../../components/NewMenu/NewMenu";

export default function MenuScreen(){
  return (
    <NewMenu></NewMenu>
  );
}